// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import mixpanel from "mixpanel-browser";

const MIXPANEL_TOKEN = "4622ffa60ea26a9646ae7463f5bab787";

export const analytics = {
  init: () => {
    mixpanel.init(MIXPANEL_TOKEN, {
      autocapture: {
        pageview: true,
        click: true,
        input: true,
        scroll: false,
        submit: true,
        capture_text_content: false,
      },
    });
  },
  identify: (id?: string, email?: string) => {
    mixpanel.identify(id);
    if (email) {
      mixpanel.people.set("email", email);
    }
  },
  inject: () => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "hs-script-loader";
    script.async = true;
    script.defer = true;
    script.src = "//js.hs-scripts.com/21984718.js";
    document.head.append(script);
  },
  refresh: () => {
    // Prevent multiple HubSpot nodes with the same ID from existing on the page as
    // created by the script being injected here. Without doing this, the user could
    // potentially see multiple overlapping popups when they click a HubSpot link.
    const selector = [
      "[id='hs-web-interactives-bottom-anchor']",
      "[id='hs-web-interactives-top-anchor']",
      "[id='hs-web-interactives-top-push-anchor']",
      "[id='hs-web-interactives-floating-container']",
    ].join(", ");
    document.querySelectorAll(selector).forEach((el) => el.remove());

    window.hubspot_web_interactives_running = false;
    const script = document.createElement("script");
    script.src = "https://js.hubspot.com/web-interactives-embed.js";
    document.head.append(script);
  },
};
